import { CSRDTopicQuestions } from "./CSRDTopicQuestions";

export const CSRD_QUESTION_COMPLETED = "COMPLETED";

export const mapCSRDTopicsData = (obj) => {
  return obj.uniqueTopics.sort().map((topicName, index) => {
    return {
      id: `navigation-topic-${index}`,
      name: topicName !== "" ? topicName : "N/A",
      data: {
        comments: obj.comments,
        questions: obj.questionsDefinitions
          .filter(el => el.topic?.toLowerCase() === topicName?.toLowerCase())
          .sort((a, b) => a.rowIndex - b.rowIndex),
        answers: obj.questionnaireData.questions?.filter(q =>
          q.topic?.toLowerCase() === topicName?.toLowerCase()) ?? [],
        year: obj.questionnaireData.year,
        topic: topicName,
        assignee: obj.questionnaireData.assignee
      },
      component: CSRDTopicQuestions,
      customTabListTitle: topicName !== "" ? topicName : "N/A",
      customTabListSubTitle: null,
      customTabPanelTitle: null
    };
  });
};